import { GetServerSideProps } from "next";

import { DoubtList } from "@/components/DoubtList";
import { DoubtsSection } from "@/components/DoubtsSection";
import { SecurityCards } from "@/components/Security/SecurityCards";
import { SecurityCover } from "@/components/Security/SecurityCover";
import { SecurityInfoCellphone } from "@/components/Security/SecurityInfoCellphone";
import { SecurityScamSection } from "@/components/Security/SecurityScamSection";
import { PlatformConfigurationConfig, PlatformConfigurationService } from "@/services/contentful/platformConfiguration";
import { SecurityPageConfig, SecurityPageService } from "@/services/contentful/securityPage";
import { Box, Stack } from "@mui/material";

const Seguranca: React.FC<SecurityPageConfig & Pick<PlatformConfigurationConfig, "contactInfo" | "ombudsmanInfo" | "ultraChannel">> = ({
  adviceText,
  infoCardTitle,
  infoCards,
  securityAppTitle,
  securityAppDescription,
  bannerCard,
  commonScamsMainCards,
  commonScamsOtherCards,
  commonScamsTitle,
  frequentQuestionsDescription,
  frequentQuestionsTitle,
  questionsAndAnswersList,
  withDoubtsDescription,
  withDoubtsTitle,
  showQuestionsAndAnswers,
  contactInfo,
  ombudsmanInfo,
  ultraChannel
}) => {
  return (
    <Stack>
      <SecurityCover adviceText={adviceText} bannerCard={bannerCard} />

      <SecurityScamSection
        commonScamsMainCards={commonScamsMainCards}
        commonScamsOtherCards={commonScamsOtherCards}
        commonScamsTitle={commonScamsTitle}
      />
      <SecurityCards infoCardTitle={infoCardTitle} infoCards={infoCards} />
      <SecurityInfoCellphone securityAppTitle={securityAppTitle} securityAppDescription={securityAppDescription} />

      {showQuestionsAndAnswers && questionsAndAnswersList?.length ? (
        <Box mx={{ lg: 8, md: 4, sm: 2, xs: 2 }} mt={{ md: "62px", xs: "48px" }}>
          <DoubtList description={frequentQuestionsDescription} title={frequentQuestionsTitle} doubtList={questionsAndAnswersList} />
        </Box>
      ) : null}

      <DoubtsSection
        title={withDoubtsTitle}
        description={withDoubtsDescription}
        contactInfo={contactInfo}
        ombudsmanInfo={ombudsmanInfo}
        ultraChannel={ultraChannel}
      />
    </Stack>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const [props, { menuItems, simulatorAccumulationInformativeText, locationCompany, contactInfo, ombudsmanInfo, ultraChannel }] = await Promise.all([
    SecurityPageService.getData(),
    PlatformConfigurationService.getData()
  ]);

  Object.assign(props, { menuItems, simulatorAccumulationInformativeText, locationCompany, contactInfo, ombudsmanInfo, ultraChannel });
  props.pageTitle = "Segurança";

  return { props };
};

export default Seguranca;
